'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _actions = require('../actions');

var _actions2 = _interopRequireDefault(_actions);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _UISimpleAvatar = require('ui-addon-avatars/UISimpleAvatar');

var _UISimpleAvatar2 = _interopRequireDefault(_UISimpleAvatar);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _UITag = require('UIComponents/tag/UITag');

var _UITag2 = _interopRequireDefault(_UITag);

var _UIIconButton = require('UIComponents/button/UIIconButton');

var _UIIconButton2 = _interopRequireDefault(_UIIconButton);

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _UIAvatarHoverlay = require('UIComponents/overlay/UIAvatarHoverlay');

var _UIAvatarHoverlay2 = _interopRequireDefault(_UIAvatarHoverlay);

var _UITruncateString = require('UIComponents/text/UITruncateString');

var _UITruncateString2 = _interopRequireDefault(_UITruncateString);

var _FormattedNumber = require('I18n/components/FormattedNumber');

var _FormattedNumber2 = _interopRequireDefault(_FormattedNumber);

var _FormattedDateTime = require('I18n/components/FormattedDateTime');

var _FormattedDateTime2 = _interopRequireDefault(_FormattedDateTime);

var _UIDropdown = require('UIComponents/dropdown/UIDropdown');

var _UIDropdown2 = _interopRequireDefault(_UIDropdown);

var _UIList = require('UIComponents/list/UIList');

var _UIList2 = _interopRequireDefault(_UIList);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _Uploader = require('./avatar/Uploader');

var _Uploader2 = _interopRequireDefault(_Uploader);

var _ = require('_');

var _UserEdit = require('./UserEdit');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SOCIALS = [{ key: 'linkedin', attr: 'linkedInUrl', icon: 'socialBlockLinkedin' }, { key: 'facebook', attr: 'facebookUrl', icon: 'socialBlockFacebook' }, { key: 'twitter', attr: 'username', icon: 'socialBlockTwitter', href: function href(u) {
    return 'https://twitter.com/' + u.username;
  } }, { key: 'google', attr: 'googleUrl', icon: 'socialBlockGoogleplus' }];

var UserPanel = function (_Component) {
  _inherits(UserPanel, _Component);

  function UserPanel(props) {
    _classCallCheck(this, UserPanel);

    var _this = _possibleConstructorReturn(this, (UserPanel.__proto__ || Object.getPrototypeOf(UserPanel)).call(this, props));

    _this.uploadClick = _this.uploadClick.bind(_this);
    return _this;
  }

  _createClass(UserPanel, [{
    key: 'uploadClick',
    value: function uploadClick() {
      (0, _Uploader2.default)({ uploadAvatar: this.props.avatarUpload });
    }
  }, {
    key: 'renderEdit',
    value: function renderEdit() {
      var _this2 = this;

      if (!this.props.editable) {
        return null;
      }
      var click = function click() {
        return _this2.props.edit((0, _UserEdit.filterAttrs)(_this2.props.user));
      };
      return _react2.default.createElement(
        _UIIconButton2.default,
        { tooltip: 'Edit', placement: 'right', className: 'edit', onClick: click },
        _react2.default.createElement(_UIIcon2.default, { name: 'pencil' })
      );
    }
  }, {
    key: 'renderSocials',
    value: function renderSocials() {
      var user = this.props.user;

      var innards = SOCIALS.filter(function (social) {
        return user[social.attr];
      }).map(function (social, idx) {
        var href = social.href ? social.href(user) : user[social.attr];
        return _react2.default.createElement(
          _UILink2.default,
          { key: social.key, className: social.key, href: href },
          _react2.default.createElement(_UIIcon2.default, { name: social.icon, className: idx === 0 ? 'first' : '' })
        );
      });
      return _react2.default.createElement(
        'div',
        { className: 'socials' },
        innards
      );
    }
  }, {
    key: 'renderAvatarInnards',
    value: function renderAvatarInnards(editable) {
      if (!editable) {
        return _react2.default.createElement(_UISimpleAvatar2.default, { src: this.props.user.avatarUrl + '/118', size: 'xl' });
      }
      return _react2.default.createElement(
        'div',
        { className: 'avatar' },
        _react2.default.createElement(
          _UIAvatarHoverlay2.default,
          {
            className: 'overlay',
            text: _react2.default.createElement(
              _UIDropdown2.default,
              { buttonText: 'edit', buttonUse: 'link-on-dark' },
              _react2.default.createElement(
                _UIList2.default,
                null,
                _react2.default.createElement(
                  _UIButton2.default,
                  { use: 'link', onClick: this.uploadClick },
                  'Upload image'
                ),
                _react2.default.createElement(
                  _UIButton2.default,
                  { use: 'link', onClick: this.props.avatarGravatar },
                  'Use Gravatar'
                ),
                _react2.default.createElement(
                  _UIButton2.default,
                  { use: 'link', onClick: this.props.avatarDelete },
                  'Remove image'
                )
              )
            ) },
          this.renderAvatarInnards(false)
        )
      );
    }
  }, {
    key: 'renderAvatar',
    value: function renderAvatar() {
      return _react2.default.createElement(
        'div',
        { className: 'avatar' },
        this.renderAvatarInnards(this.props.editable)
      );
    }
  }, {
    key: 'renderName',
    value: function renderName() {
      var user = this.props.user;

      return _react2.default.createElement(
        'h4',
        null,
        user.firstName,
        ' ',
        user.lastName
      );
    }
  }, {
    key: 'renderPoints',
    value: function renderPoints() {
      var user = this.props.user;
      var points = user.points;
      var pointsLabel = 'Point';
      if (user.karmaPoints > 0) {
        points = user.karmaPoints;
        pointsLabel = 'Karma Point';
      }
      if (points < 10) {
        return null;
      }
      pointsLabel = pointsLabel + (points === 1 ? '' : 's');
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { className: 'separator' }),
        _react2.default.createElement(
          'h1',
          { className: 'points' },
          _react2.default.createElement(_FormattedNumber2.default, { value: points || 0 })
        ),
        _react2.default.createElement(
          'div',
          { className: 'points' },
          pointsLabel
        )
      );
    }
  }, {
    key: 'renderLocation',
    value: function renderLocation() {
      var location = this.props.user.location;

      if (location) {
        return _react2.default.createElement(
          'div',
          { className: 'location' },
          _react2.default.createElement(_UIIcon2.default, { name: 'location' }),
          ' ',
          location
        );
      }
      return null;
    }
  }, {
    key: 'renderWebsite',
    value: function renderWebsite() {
      var website = this.props.user.website;

      if (website) {
        return _react2.default.createElement(
          'div',
          { className: 'website' },
          _react2.default.createElement(_UIIcon2.default, { name: 'link' }),
          _react2.default.createElement(
            _UILink2.default,
            { href: website },
            _react2.default.createElement(
              _UITruncateString2.default,
              { maxWidth: 250, tooltip: false },
              website.split('://').pop()
            )
          )
        );
      }
      return null;
    }
  }, {
    key: 'renderInfo',
    value: function renderInfo() {
      var user = this.props.user;


      var location = this.renderLocation();
      var website = this.renderWebsite();

      var work = [];
      var company = user.company;
      if (!company && user.companyWebsite) {
        company = user.companyWebsite.split('://').pop();
      }
      if (company) {
        if (user.companyWebsite) {
          work.push(_react2.default.createElement(
            _UILink2.default,
            { key: 'company', href: user.companyWebsite },
            company
          ));
        } else {
          work.push(_react2.default.createElement(
            'span',
            { key: 'company' },
            company
          ));
        }
      }
      if (user.jobTitle) {
        work = [_react2.default.createElement(
          'span',
          { key: 'title' },
          user.jobTitle,
          work ? ' at ' : ''
        ), work];
      }
      if (work.length > 0) {
        work.unshift(_react2.default.createElement(
          'span',
          { key: 'space' },
          '\xA0'
        ));
        work.unshift(_react2.default.createElement(_UIIcon2.default, { key: 'icon', name: 'theme' }));
      }

      if (location == null && work.length === 0 && website == null) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { className: 'separator' }),
        location,
        _react2.default.createElement(
          'div',
          { className: 'work' },
          work
        ),
        website
      );
    }
  }, {
    key: 'renderBio',
    value: function renderBio() {
      var bio = this.props.user.bio;

      if (bio) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('div', { className: 'separator' }),
          _react2.default.createElement(
            'div',
            { className: 'bio' },
            bio
          )
        );
      }
      return null;
    }

    // <UILink use="danger" onClick={() => this.props.unfollow(id)}>{'\u00d7'}</UILink>

  }, {
    key: 'renderFollowings',
    value: function renderFollowings() {
      var _this3 = this;

      var _props$user = this.props.user,
          followersCount = _props$user.followersCount,
          followed = _props$user.followed,
          id = _props$user.id;

      var lines = [];
      if (followersCount > 0) {
        lines.push(_react2.default.createElement(
          'div',
          { className: 'followers', key: 'followers' },
          _react2.default.createElement(
            'span',
            { className: 'count' },
            followersCount
          ),
          ' follower',
          followersCount > 1 ? 's' : ''
        ));
      }
      if (followed) {
        lines.push(_react2.default.createElement(
          'div',
          { className: 'followed', key: 'followed' },
          _react2.default.createElement(
            _UITag2.default,
            { use: 'default' },
            'Following'
          ),
          _react2.default.createElement(
            _UIButton2.default,
            { use: 'primary', size: 'small', onClick: function onClick() {
                return _this3.props.unfollow(id);
              } },
            'Unfollow'
          )
        ));
      } else if (this.props.loggedin && !this.props.editable) {
        lines.push(_react2.default.createElement(
          'div',
          { key: 'followed' },
          _react2.default.createElement(
            _UIButton2.default,
            { use: 'primary', size: 'small', onClick: function onClick() {
                return _this3.props.follow(id);
              } },
            'Follow'
          )
        ));
      }
      if (!lines.length) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: "followings" },
        lines
      );
    }
  }, {
    key: 'renderSince',
    value: function renderSince() {
      var establishedAt = this.props.user.establishedAt;

      if (establishedAt) {
        return _react2.default.createElement(
          'div',
          { className: 'since' },
          'Member since:',
          ' ',
          _react2.default.createElement(_FormattedDateTime2.default, { value: establishedAt, format: 'LL', type: 'userTz' })
        );
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'user-panel' },
        this.renderEdit(),
        this.renderAvatar(),
        this.renderName(),
        this.renderSocials(),
        this.renderInfo(),
        this.renderBio(),
        this.renderPoints(),
        this.renderFollowings(),
        this.renderSince()
      );
    }
  }]);

  return UserPanel;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var user = _ref.user,
      auth = _ref.auth;

  return {
    user: _extends({}, user, user.staged),
    editable: user.id === auth.id,
    loggedin: !!auth.id
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  edit: function edit(changes) {
    return (0, _actions.createAction)(_actions2.default.USER_EDIT, changes);
  },
  avatarDelete: function avatarDelete() {
    return (0, _actions.createAction)(_actions2.default.AVATAR_DELETE);
  },
  avatarGravatar: function avatarGravatar() {
    return (0, _actions.createAction)(_actions2.default.AVATAR_GRAVATAR);
  },
  avatarUpload: function avatarUpload(blob) {
    return (0, _actions.createAction)(_actions2.default.AVATAR_UPLOAD, blob);
  },
  follow: function follow(userId) {
    return (0, _actions.createAction)(_actions2.default.FOLLOW, userId);
  },
  unfollow: function unfollow(userId) {
    return (0, _actions.createAction)(_actions2.default.UNFOLLOW, userId);
  }
})(UserPanel);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/UserPanel.js
// module id = 280
// module chunks = 0